import * as React from 'react';
import { ChevronDown } from 'react-feather';
import styled from 'styled-components';
import { color, height, space, width } from 'styled-system';
import { StyledSystemProps } from '../theme/StyledSystemProps';
import { Breadcrumbs } from '../components';
import { RouteComponentProps, withRouter } from 'react-router';
import Box from './primitives/Box';
import DropdownMenu from './DropdownMenu';
import { H4 } from '../typography';
import { ThemeInterface } from '../theme/ThemeInterface';
import { SteynCityContext } from './ContextProvider';
import { getLoggedInUser } from '../utils/helpers';
import { IS_VENDOR } from '../consts/index';

type HeaderProps = StyledSystemProps &
  RouteComponentProps & {
    color?: string;
    size?: number;
    id?: string;
    getLoggedInUser?: () => { firstName?: string; lastName?: string; id: string };
  };

type HeaderState = {
  menuOpen: boolean;
};

const HeaderCont = styled.div`
  ${space};
  ${width};
  ${color};
  ${height};
  display: flex;
  align-items: center;
  box-sizing: border-box;
  justify-content: space-between;
  box-shadow: 0 1px 4px rgba(50, 50, 93, 0.4);
`;

const BreadCrumbCont = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

const StyledExpand = styled(ChevronDown)<any>`
  margin-left: 10px;
  color: ${(props: ThemeInterface) => props.theme.colors.white};
  transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94) !important;
  transform: ${props => (props.open ? 'rotateX(180deg)' : 'rotateX(0deg)')};
`;

class Header extends React.Component<HeaderProps, HeaderState> {
  static contextType = SteynCityContext;
  static defaultProps = {
    p: 4,
    bg: IS_VENDOR ? 'charcoalGrey' : 'putty',
    color: 'white',
    height: '70px',
  };
  context!: React.ContextType<typeof SteynCityContext>;

  constructor(props: HeaderProps) {
    super(props);
    this.state = {
      menuOpen: false,
    };
  }

  handleLogout = () => {
    const { history } = this.props;
    window.localStorage.clear();
    history.push('/');
  };

  componentDidMount() {
    const { user, setUser } = this.context;
    if (!user) {
      const loggedInUser = getLoggedInUser();
      setUser(loggedInUser);
    }
  }

  render() {
    const { user } = this.context;
    const { menuOpen } = this.state;
    return (
      <React.Fragment>
        <HeaderCont {...this.props}>
          <BreadCrumbCont>
            <Breadcrumbs />
          </BreadCrumbCont>
          <Box flexDirection="row">
            <Box flexDirection="row" justifyContent="center" alignItems="center">
              <H4
                color={this.props.color}
                pointer={true}
                onClick={() => this.setState({ menuOpen: !this.state.menuOpen })}
                fontWeight={300}
              >
                {user && user.firstName ? user.firstName + ' ' + user.lastName : null}
              </H4>
              <StyledExpand size={18} open={menuOpen} />
            </Box>
          </Box>
        </HeaderCont>
        <DropdownMenu
          onClose={() => this.setState({ menuOpen: !this.state.menuOpen })}
          menuOpen={menuOpen}
          menuItems={[
            {
              title: 'Profile',
              onClick: () => {
                this.setState({
                  menuOpen: false,
                });
                this.props.history.push(`/profile/${user && user.id}`);
              },
            },
            { title: 'Log Out', onClick: () => this.handleLogout() },
          ]}
        />
      </React.Fragment>
    );
  }
}

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/components/Header.tsx